import React from 'react';
export const TermsAndConditions = () => {
  return <div className="w-full min-h-screen bg-[#000000] text-white" data-id="element-453">
      <div className="max-w-4xl mx-auto px-4 py-12" data-id="element-454">
        {/* Logo */}
        <div className="flex justify-center mb-12" data-id="element-455">
          <img src="https://cdn.magicpatterns.com/uploads/pPv8sZAUYxABkDBucNAnxU/esa.png" alt="Equip Sales Academy Logo" className="h-16 sm:h-20" data-id="element-456" />
        </div>

        {/* Content */}
        <h1 className="text-4xl sm:text-5xl font-black mb-8 text-center" data-id="element-457">
          Terms and Conditions
        </h1>

        <div className="space-y-8 text-white/90 leading-relaxed" data-id="element-458">
          <section data-id="element-459">
            <h2 className="text-2xl font-bold mb-4 text-white" data-id="element-460">
              1. Acceptance of Terms
            </h2>
            <p data-id="element-461">
              By accessing and using the services provided by Equip Sales
              Academy ("we," "our," or "us"), you accept and agree to be bound
              by these Terms and Conditions. If you do not agree to these terms,
              please do not use our services.
            </p>
          </section>

          <section data-id="element-462">
            <h2 className="text-2xl font-bold mb-4 text-white" data-id="element-463">
              2. Services Description
            </h2>
            <p className="mb-4" data-id="element-464">
              Equip Sales Academy provides sales team operating system
              implementation services, including but not limited to:
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-465">
              <li data-id="element-466">Sales compensation structure design and implementation</li>
              <li data-id="element-467">KPI definition and dashboard setup</li>
              <li data-id="element-468">Sales cadence and culture development</li>
              <li data-id="element-469">CRM optimization and pipeline management</li>
              <li data-id="element-470">Sales leadership coaching and training</li>
            </ul>
          </section>

          <section data-id="element-471">
            <h2 className="text-2xl font-bold mb-4 text-white" data-id="element-472">
              3. Engagement Terms
            </h2>
            <p className="mb-4" data-id="element-473">
              Our standard engagement includes a 120-day implementation period.
              Specific terms, including pricing, will be outlined in your
              individual service agreement.
            </p>
            <p className="mb-4" data-id="element-474">Key engagement terms include:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-475">
              <li data-id="element-476">
                Payment is required before the commencement of services unless
                otherwise agreed in writing
              </li>
              <li data-id="element-477">
                Cancellation or refund policies will be specified in your
                service agreement
              </li>
              <li data-id="element-478">
                You are responsible for providing timely access to your team,
                systems, and data
              </li>
              <li data-id="element-479">
                Implementation timelines are estimates and may vary based on
                your organization's readiness and cooperation
              </li>
            </ul>
          </section>

          <section data-id="element-480">
            <h2 className="text-2xl font-bold mb-4 text-white" data-id="element-481">
              4. Client Responsibilities
            </h2>
            <p className="mb-4" data-id="element-482">As a client, you agree to:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-483">
              <li data-id="element-484">
                Provide accurate and complete information about your sales
                organization
              </li>
              <li data-id="element-485">Grant necessary access to systems, data, and team members</li>
              <li data-id="element-486">Participate actively in scheduled sessions and reviews</li>
              <li data-id="element-487">
                Implement recommendations in good faith with your sales team
              </li>
              <li data-id="element-488">
                Maintain confidentiality of proprietary methodologies and
                materials
              </li>
            </ul>
          </section>

          <section data-id="element-489">
            <h2 className="text-2xl font-bold mb-4 text-white" data-id="element-490">
              5. Intellectual Property
            </h2>
            <p className="mb-4" data-id="element-491">
              All materials, methodologies, frameworks, and content provided by
              Equip Sales Academy remain our intellectual property. You receive
              a limited, non-exclusive license to use these materials solely for
              your internal business operations.
            </p>
            <p data-id="element-492">
              You may not reproduce, distribute, or create derivative works from
              our materials without express written permission.
            </p>
          </section>

          <section data-id="element-493">
            <h2 className="text-2xl font-bold mb-4 text-white" data-id="element-494">
              6. Results and Guarantees
            </h2>
            <p data-id="element-495">
              While we have a proven track record of success, we cannot
              guarantee specific results. Outcomes depend on numerous factors
              including your team's execution, market conditions, lead quality,
              and organizational commitment. We provide a system and
              implementation support, but ultimate results depend on your
              organization's application of the system.
            </p>
          </section>

          <section data-id="element-496">
            <h2 className="text-2xl font-bold mb-4 text-white" data-id="element-497">
              7. Confidentiality
            </h2>
            <p data-id="element-498">
              Both parties agree to maintain confidentiality of proprietary
              information shared during the engagement. This includes business
              strategies, financial information, customer data, and proprietary
              methodologies.
            </p>
          </section>

          <section data-id="element-499">
            <h2 className="text-2xl font-bold mb-4 text-white" data-id="element-500">
              8. Limitation of Liability
            </h2>
            <p data-id="element-501">
              To the maximum extent permitted by law, Equip Sales Academy shall
              not be liable for any indirect, incidental, special,
              consequential, or punitive damages, or any loss of profits or
              revenues, whether incurred directly or indirectly.
            </p>
          </section>

          <section data-id="element-502">
            <h2 className="text-2xl font-bold mb-4 text-white" data-id="element-503">
              9. Termination
            </h2>
            <p data-id="element-504">
              Either party may terminate the engagement according to the terms
              specified in the service agreement. Upon termination, you must
              cease using our proprietary materials and methodologies.
            </p>
          </section>

          <section data-id="element-505">
            <h2 className="text-2xl font-bold mb-4 text-white" data-id="element-506">
              10. Governing Law
            </h2>
            <p data-id="element-507">
              These Terms and Conditions shall be governed by and construed in
              accordance with the laws of the jurisdiction in which Equip Sales
              Academy operates, without regard to its conflict of law
              provisions.
            </p>
          </section>

          <section data-id="element-508">
            <h2 className="text-2xl font-bold mb-4 text-white" data-id="element-509">
              11. Changes to Terms
            </h2>
            <p data-id="element-510">
              We reserve the right to modify these Terms and Conditions at any
              time. Changes will be effective immediately upon posting. Your
              continued use of our services constitutes acceptance of the
              modified terms.
            </p>
          </section>

          <section data-id="element-511">
            <h2 className="text-2xl font-bold mb-4 text-white" data-id="element-512">
              12. Contact Information
            </h2>
            <p data-id="element-513">
              For questions about these Terms and Conditions, please contact us
              at:
            </p>
            <p className="mt-4" data-id="element-514">
              <strong data-id="element-515">Equip Sales Academy</strong>
              <br data-id="element-516" />
              Email: legal@equipsales.io
            </p>
          </section>

          <div className="pt-8 border-t border-white/20 text-center text-white/60" data-id="element-517">
            <p data-id="element-518">Last Updated: January 14, 2026</p>
          </div>
        </div>

        {/* Back to Home Link */}
        <div className="mt-12 text-center" data-id="element-519">
          <a href="/" className="inline-flex items-center gap-2 text-white hover:text-white/80 transition-colors" data-id="element-520">
            ← Back to Home
          </a>
        </div>
      </div>
    </div>;
};